import { useAppSelector } from 'app/hooks';
import { AxiosError } from 'axios';
import FeatureTitleBar from 'components/common/FeatureTitleBar';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import { selectIsEditMode } from 'features/common/editModeSlice';
import { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { displayError, handleServiceError } from 'utils/axiosError';
import TableList from '../components/TableList';
import { ApplicableCourse, ApplicableCoursePayload, SearchApplicableCoursePayload } from '../models/courseOrderLimit';
import { courseOrderLimitService } from '../services';
export interface ListApplicableCourseReturnData {
  selectedApplicableCourse: Array<{ id: number; name: string }>;
}

export interface ListApplicableCoursesModalProps {
  limitTypeId: number;
  limitTypeName: string;
  exceptApplicableCourseIds?: number[];
  onReflect?: (returnData: ListApplicableCourseReturnData) => void;
  onClose: () => void;
}

function ListApplicableCoursesModal({
  limitTypeId,
  limitTypeName,
  exceptApplicableCourseIds = [],
  onReflect,
  onClose,
}: ListApplicableCoursesModalProps) {
  // Define state
  const [dataTable, setDataTable] = useState<ApplicableCourse[]>([]);

  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();

  // selectors
  const isEditMode = useAppSelector(selectIsEditMode);

  async function fetchData() {
    try {
      const payload: SearchApplicableCoursePayload = {
        courseName: '',
        menuBookName: '',
        limitType: limitTypeId,
      };
      const respone = await courseOrderLimitService.getCourseOrderLimitList(payload);
      const processedData = respone.data.map((course) => ({
        ...course,
        course_id: course.id,
      }));

      setDataTable(processedData);
    } catch (error) {
      if (!handleServiceError(showGlobalModal, error as AxiosError)) {
        displayError(showGlobalModal, error as AxiosError);
      }
    }
  }
  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);
  async function saveData(data: Array<{ id: number; name: string }>) {
    try {
      const payload: ApplicableCoursePayload[] = data.map((item) => ({
        course_id: item.id,
        limit_type: limitTypeId,
      }));

      await courseOrderLimitService.addCourseOrderLimit(payload);
    } catch (error) {
      if (!handleServiceError(showGlobalModal, error as AxiosError)) {
        displayError(showGlobalModal, error as AxiosError);
      }
    }
  }

  async function handleBtnOnReflect(
    selectedApplicableCourse: Array<{ id: number; name: string; menu_book_name: string; menu_book_id: number }>
  ) {
    if (onReflect) onReflect({ selectedApplicableCourse });
    await saveData(selectedApplicableCourse);
    await fetchData();
  }

  return (
    <>
      <Modal dialogClassName="list-applicable-course-modal" show backdrop="static" onHide={onClose} centered>
        <Modal.Header closeButton className={isEditMode ? 'reedit-mode-wrapper' : ''}>
          <FeatureTitleBar title={t('applicableCoursesModal.title')} />
        </Modal.Header>
        <Modal.Body className={isEditMode ? 'reedit-mode-wrapper' : ''}>
          <div className="mb-3 fw-bold">{`${t('applicableCoursesModal.restrictions')} : ${limitTypeName}`}</div>
          <div>
            {dataTable && (
              <TableList
                dataTable={dataTable}
                onReflect={handleBtnOnReflect}
                setDataTable={setDataTable}
                exceptApplicableCourseIds={exceptApplicableCourseIds}
                limitType={limitTypeId}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default ListApplicableCoursesModal;
